export const COPY_DATA = {
  collegeMajor: {
    h1: ["Goodbye Uncertainty.", "Hello Direction."],
    h2: "Discover the perfect major that aligns with your passions and strengths.",
    card1: ["Find Your Fit", "Uncover majors that resonate with your interests and abilities."],
    card2: ["Plan Your Path", "Get a personalized roadmap with your interests and abilities."],
    card3: ["Unlock Potential", "Identify opportunities that set you up for future success."],
    h3: [
      "Crafted by educational and career experts who understand students.",
      "Our team of 30+ experts helps students like you find clarity and confidence in choosing a major."
    ]
  },
  careerSwitch: {
    h1: ["Goodbye Uncertainty.", "Hello Clarity."],
    h2: "You have what it takes. Let's <i>unlock</i> it together.",
    card1: ["Clear Career Path", "See exactly where your strengths can take you with a personalized career plan."],
    card2: ["Discover New Opportunities", "Reveal career paths and roles you never knew were within reach."],
    card3: ["Actionable Steps Forward", "Turn insights into concrete actions to start your career shift today."],
    h3: [
      "Designed by career experts who specialize in career change.",
      "Our 30+ experts help professionals like you take the next step with confidence and purpose."
    ]
  },
  advance: {
    h1: ["Goodbye Plateau.", "Hello Growth."],
    h2: "Elevate your career to new heights with a <i>clear plan</i>.",
    card1: ["Accelerate Your Progress", "Get personalized strategies to reach your next promotion faster."],
    card2: ["Maximize Your Potential", "Uncover hidden strengths that can propel you forward."],
    card3: ["Achieve Your Goals", "Outline actionable steps to climb the career ladder."],
    h3: [
      "Empowered by experts in career advancement.",
      "Our team helps professionals like you achieve new heights in their current careers."
    ]
  },
  ai: {
    h1: ["Goodbye Uncertainty.", "Hello Insight."],
    h2: "Stay <i>ahead</i> in a rapidly changing technological landscape.",
    card1: ["Future-Proof Your Career", "Understand how AI and emerging technologies affect your field."],
    card2: ["Embrace Innovation", "Discover how to leverage tech advancements for career growth."],
    card3: ["Adapt and Thrive", "Develop strategies to stay relevant and competitive."],
    h3: [
      "Guided by tech-savvy career experts.",
      "Our 30+ specialists help professionals navigate the evolving world of technology with confidence."
    ]
  },
  lost: {
    h1: ["Goodbye Feeling Lost.", "Hello Clarity."],
    h2: "Your future isn't lost. It's waiting to be <i>revealed</i>.",
    card1: [
      "Clear Career Path",
      "Know exactly where you’re headed with a personalized roadmap designed for your strengths and goals."
    ],
    card2: [
      "Unlock Hidden Strengths",
      "Discover talents and strengths you didn’t realize you had, opening doors to new career paths."
    ],
    card3: [
      "Turn Confusion into Action",
      "Transform uncertainty into a clear plan, with guidance on where to focus your energy next."
    ],
    h3: [
      "Built by career experts who understand you.",
      "Created by 30+ career experts who specialize in helping you move from stuck to thriving."
    ]
  },
  return: {
    h1: ["Goodbye Hesitation.", "Hello Opportunity."],
    h2: "Re-enter the workforce with <i>clarity</i> and <i>confidence</i>.",
    card1: ["Refresh Your Skills", "Identify strengths and areas for development."],
    card2: ["Explore New Paths", "Find roles that value your experience and align with your goals."],
    card3: ["Smooth Transition", "Get personalized guidance to navigate your return to work."],
    h3: [
      "Backed by experts in career re-entry.",
      "Our 30+ specialists help you confidently step back into the workforce."
    ]
  },
  other: {
    h1: ["Goodbye Limitations.", "Hello Possibilities."],
    h2: "Unlock new opportunities tailored to <i>you</i>.",
    card1: ["Custom Career Paths", "Explore options that align with your unique aspirations."],
    card2: ["Personalized Insights", "Gain understanding of your strengths and how to leverage them."],
    card3: ["Empower Your Journey", "Take control with a clear path forward."],
    h3: [
      "Personalized support from experienced career experts.",
      "Our 30+ specialists are dedicated to helping you achieve your career goals."
    ]
  }
}

export const IMAGE_DATA = {
  collegeMajor: {
    mobile: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/collegeMajor_all_all_AR1x1.webp",
    desktop: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/collegeMajor_all_all_AR2x1.webp"
  },
  other: {
    male: {
      less30: {
        mobile:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_male_less30_AR1x1.webp",
        desktop:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_male_less30_AR2x1.webp"
      },
      over30: {
        mobile:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_male_over30_AR1x1.webp",
        desktop:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_male_over30_AR2x1.webp"
      }
    },
    other: {
      less30: {
        mobile:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_female%2Bnonbinary%2Bother_less30_AR1x1.webp",
        desktop:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_female%2Bnonbinary%2Bother_less30_AR2x1.webp"
      },
      over30: {
        mobile:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_female%2Bnonbinary%2Bother_over30_AR1x1.webp",
        desktop:
          "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/CRO/careerSwitch%2Badvance%2Bai%2Blost%2Bother_female%2Bnonbinary%2Bother_over30_AR2x1.webp"
      }
    }
  }
}
